<template>
<div class="chapter">
<div class="inner_page">
<div class="preface" id="itr">
<h1 class="chapter"><a id="pagexii"></a><a id="pagexiii"></a><em>FOREWORD</em></h1>
<p class="indent">    <span class="big">T</span>he first time I watched the Blue Angels perform, I was a plebe at the United States Naval Academy. They flew overhead in their shiny new Bearcats to put on a show. Wow! So this is what naval aviation is all about. I often wondered how many young men were influenced by the spectacular showmanship of the navy’s best aviators to become pilots themselves.</p>
<p class="indent">To be a naval aviator is a unique experience. To fly with the Blue Angels is a cherished assignment and a recognition of superb flying skills— but to be the leader of the “Blues” is the ultimate achievement in flying ability: the best of the best. Such a naval aviator was Roy Marlen “Butch” Voris—the First Blue.</p>
<p class="indent">This book relates the fascinating aeronautical life of Butch Voris. He was a World War II ace, flying Hellcats against the Japanese. There he learned his acrobatic skills dogfighting with the enemy. He was a natural to head up the navy’s first acrobatic flying team. His excellent leadership developed a team of aviators that were the best in the world.</p>
<p class="indent">In these pages you will learn about his close calls and crashes; his teammates; the transition from props to jets; Washington politics; his experience at Grumman Aircraft; and finally, finishing his career with NASA.</p>
<p class="indent">When you open the pages of this book, you will be flying with the <a id="pagexiv"></a>leader of the “Blues.” Fasten your seatbelt. The “air show” is about to begin.</p>
<p class="right">James A. Lovell</p>
<p class="right1">(Captain, U.S. Navy, Ret.,<br/>and former NASA Astronaut)</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780312322496_epub_itr_r1.vue?fd996dc8